<!-- a11y: prevent default browser submit on Enter / mobile "Search" key; see search-station-form for full rationale. -->
<form
  [formGroup]="routePlannerForm"
  class="route-planner-form h-full"
  (ngSubmit)="submitRoutePlannerForm()"
>
  <div class="flex flex-col h-full w-full gap-4">
    <div
      class="flex flex-col gap-4 bg-white rounded-b-xl p-4 shadow-lg"
      [class]="direction"
      >
      <mot-autocomplete
        formControlName="origin"
        [readOnly]="true"
        [displayErrors]="false"
        appearance="fill"
        inputIcon="arrow-down-arrow-up"
        inputIconClass="cursor-pointer text-2xl text-white ml-2 p-1 bg-primary rounded-3xl"
        inputClass="cursor-pointer"
        [label]="originText"
        (onClick)="
          openAutocomplete(getFormControl('origin'), searchOriginText, 'org')
        "
        (onIconClick)="switchLocations()"
        [iconButtonAriaLabel]="switchLocationsText"
        fieldClass="cursor-pointer bg-transparent w-full !text-default"
        [displayFn]="routePlanningService.displayAddressName"
        />

        <mot-autocomplete
          formControlName="destination"
          [readOnly]="true"
          appearance="fill"
          [displayErrors]="false"
          fieldClass="w-full !text-default"
          inputClass="cursor-pointer"
          [label]="destinationText"
        (onClick)="
          openAutocomplete(
            getFormControl('destination'),
            searchDestinationText,
            'dest'
          )
        "
          [displayFn]="routePlanningService.displayAddressName"
          />

          <mot-button
            type="button"
            icon="bars-filter"
            (onClick)="openFilterMenu()" ariaHaspopup="dialog"
            [disableRipple]="true"
            buttonClass="!text-default font-bold !shadow-none !py-0 px-2 !bg-transparent text-base"
            [textClass]="appliedFilters ? 'filters-active' : ''"
            iconClass="!text-2xl"
            [text]="filterText"
            />
          </div>

          <div class="flex-1 flex flex-col items-center gap-4 px-4">
            <div class="w-full" [class]="direction">
              <mot-button-toggle
                [options]="legSections"
                formControlName="isFirstLeg"
                [groupAriaLabel]="carLegRadioGroupLabel"
                toggleClass="flex-1"
                class="w-full"
              ></mot-button-toggle>
            </div>

            <div class="flex flex-col gap-4 w-full">
              <div class="flex gap-2">
                <ng-icon name="circle-info" class="text-2xl"/>
                <div class="flex flex-col gap-2" [class]="direction">
                  <span class="text-base">{{ pickStopText }}</span>
                  <span class="text-sm font-normal">{{ isFirstLeg() ? startOnCarText : endOnCarText }}</span>
                </div>
              </div>
              <mot-select
                [formControl]="getFormControl('legOpt')"
                [displayErrors]="false"
                class="w-full !text-default"
                [label]="stopTypeText"
                [options]="legOptions"
                >
              </mot-select>

              <div formGroupName="legLocation">
                @if (
                  routePlannerForm.controls['legOpt'].value == eLegOptions.ADDRESS
                  ) {
                  <mot-autocomplete
                    formControlName="legAddress"
                    [readOnly]="true"
                    appearance="fill"
                    [displayErrors]="false"
                    fieldClass="w-full !text-default"
                    inputClass="cursor-pointer"
                    [label]="stopAddressText"
            (onClick)="
              openAutocomplete(
                getFormControl('legLocation.legAddress'),
                searchStopText,
                'leg'
              )
            "
                    [displayFn]="routePlanningService.displayAddressName"
                    />
                }

                @if (
                  routePlannerForm.controls['legOpt'].value ==
                  eLegOptions.TRAIN_STATIONS
                  ) {
                  <mot-autocomplete
                    formControlName="trainStation"
                    [displayErrors]="false"
                    appearance="fill"
                    fieldClass="w-full !text-default"
                    [label]="trainStationsText"
                    [options]="filteredTrainStationsOptions"
                    [displayFn]="routePlanningService.displayAddressName"
                    (textChange)="onTrainStationTextChange($event)"
                    (onOptionSelected)="onTrainStationSelected($event)"
                    />
                }

                @if (
                  routePlannerForm.controls['legOpt'].value ==
                  eLegOptions.PARK_AND_RIDE
                  ) {
                  <mot-autocomplete
                    formControlName="parkAndRideLot"
                    [displayErrors]="false"
                    appearance="fill"
                    fieldClass="w-full !text-default"
                    [label]="parkingLotsText"
                    [options]="filteredParkingLotsOptions"
                    [displayFn]="routePlanningService.displayAddressName"
                    (textChange)="onParkingLotTextChange($event)"
                    (onOptionSelected)="onParkingLotSelected($event)"
                    />
                }
              </div>

              <mot-date-time-picking-form
                [arrivalFormGroup]="getNestedGroup('arrival')"
                [departureFormGroup]="getNestedGroup('departure')"
                [timeOptFormControl]="getFormControl('timeOpt')"
                />
              </div>
            </div>
          </div>
        </form>
